arrLike